<template>
  <div class="home-wrapper">
    <MyHeader />
    <router-view />
    <MyFooter v-show="isShow" />
  </div>
</template>

<script>
import MyHeader from '@/components/MyHeader.vue'
import MyFooter from '@/components/MyFooter.vue'
import { mapGetters } from 'vuex'
import { parseJsonValue } from '@/utils/utils'

export default {
  name: 'HomeView',
  components: {
    MyHeader,
    MyFooter,
  },
  data() {
    return {
      isShow: true,
    }
  },
  computed: {
    ...mapGetters(['pathParams']),
  },
  created() {
    if (!['/', '/login', '/homeIndex'].includes(this.$route.path) && window.performance.navigation.type == 1) {
      if (sessionStorage.getItem('refreshFlag') && sessionStorage.getItem('refreshFlag') == 1) {
        const jumpParams = sessionStorage.getItem('jumpParams')
          ? parseJsonValue(sessionStorage.getItem('jumpParams'))
          : null
        if (jumpParams) this.$router.replace({ path: '/', query: { ...jumpParams } })
      } else {
        if (!sessionStorage.getItem('token')) {
          this.$router.replace('/login')
        } else {
          this.$router.replace('/homeIndex')
        }
      }
    }
  },
  mounted() {
    if (['/', '/login', '/homeIndex'].includes(this.$route.path) && JSON.stringify(this.$route.query) != '{}') {
      const langMap = {
        'zh-CN': 'zh-CN',
        'en-US': 'en-US',
        zh: 'zh-CN',
        en: 'en-US',
        cn: 'zh-CN',
        us: 'en-US',
        CN: 'zh-CN',
        US: 'en-US',
      }
      try {
        setTimeout(() => {
          this.$store.commit('app/SET_LANGUAGE', langMap?.[this.$route?.query?.culture] || 'zh-CN')
        }, 300)
      } catch (error) {
        console.log('error', error)
        if (!sessionStorage.getItem('token')) {
          this.$store.commit('user/LOGOUT')
          this.$router.replace('/login')
        } else {
          this.$router.replace('/homeIndex')
        }
      }
    }
    const height = document.body.clientHeight
    window.addEventListener('resize', () => {
      if (document.body.clientHeight < height) {
        this.isShow = false
      } else {
        this.isShow = true
      }
    })
  },
  updated() {},
  methods: {},
}
</script>
<style scoped lang="less">
.home-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
